// home-routing.module.ts

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { TranslatePdfComponent } from './journey/translate-pdf/translate-pdf.component';
import { CortevaDbComponent } from './journey/corteva-db/corteva-db.component';
import { CompanyLeaderboardComponent } from './journey/company-leaderboard/company-leaderboard.component';

const routes: Routes = [
  {
    path: 'genie',
    component: HomeComponent,
    children: [
      {
        path: 'journey',
        loadChildren: () =>
          import('./journey/journey.module').then((m) => m.JourneyModule),
      },
      {
        path: 'translate-pdf',
        component: TranslatePdfComponent,
      },
      {
        path: 'corteva-database',
        component: CortevaDbComponent,
      },
      {
        path: 'company-leaderboard',
        component: CompanyLeaderboardComponent,
      },
      {
        path: 'multiplayer',
        loadChildren: () =>
          import('./multiplayer/multiplayer.module').then((m) => m.MultiplayerModule),
      },
      // { path: '', redirectTo: 'journey', pathMatch: 'full' },
      { path: '**', redirectTo: 'journey' }, // Redirect to error page for unknown routes
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
